import { render, staticRenderFns } from "./terms_conditions.vue?vue&type=template&id=605df54b&scoped=true&"
import script from "./terms_conditions.vue?vue&type=script&lang=js&"
export * from "./terms_conditions.vue?vue&type=script&lang=js&"
import style0 from "./terms_conditions.vue?vue&type=style&index=0&id=605df54b&prod&scoped=true&lang=css&"
import style1 from "./terms_conditions.vue?vue&type=style&index=1&id=605df54b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605df54b",
  null
  
)

export default component.exports